import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../components/Header.css'; // 复用 Header / 下载弹窗样式

/**
 * Universal Link 中转页（/p/:id）
 * 装了 App 的用户在本页加载前，已被 iOS 通过 Universal Link 直接唤起进 App，本页不会渲染。
 * 能走到这里说明：没装 App（或在微信内）。
 *  - 非微信移动端 → 自动跳 App Store
 *  - 其余（微信 / 桌面）→ 展示二维码 + App Store 角标，引导下载
 */
export const AppRedirectPage = () => {
    const { id } = useParams();
    const appStoreUrl = 'https://apps.apple.com/us/app/marlo-connect-meet-nearby/id6450737280?l=zh-Hans-CN';

    useEffect(() => {
        const ua = navigator.userAgent || '';
        const isWeChat = /micromessenger/i.test(ua);
        const isMobile = /iphone|ipad|ipod|android/i.test(ua);
        if (!isWeChat && isMobile) {
            window.location.replace(appStoreUrl);
        }
    }, [appStoreUrl]);

    return (
        <div className="download-modal-overlay" style={{ position: 'fixed', zIndex: 9999 }}>
            <div className="download-modal-content">
                <div className="download-modal-body">
                    <img
                        src={require('../images/download/qr.png')}
                        alt="QR Code"
                        className="qr-code"
                    />
                    <div className="download-or-text">OR</div>
                    <img
                        src={require('../images/download/store.png')}
                        alt="App Store"
                        className="store-badge"
                        onClick={() => window.open(appStoreUrl, '_blank')}
                        style={{ cursor: 'pointer' }}
                    />
                    <p className="download-description">
                        Download Marlo to find your<br/>people nearby.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default AppRedirectPage;
